(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-quotify-button"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function humanizeName(name) {
    return String(name || '').trim()
      .replace(/^_+/, '')
      .replace(/[-_\s]+/g, ' ')
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function getProperties() {
    var properties = {};

    document.querySelectorAll('[name^="properties["]').forEach(function (field) {
      var match = field.name.match(/^properties\[([^_][^\]]*)\]$/);
      if (!match) return;

      var name = humanizeName(match[1]);
      var type = (field.type || '').toLowerCase();
      var value;

      if ((type === 'checkbox' || type === 'radio') && !field.checked) return;

      if (type === 'file') {
        value = field.files && field.files.length
          ? Array.from(field.files, function (f) { return f.name; })
          : null;
      } else if (field.tagName === 'SELECT' && field.multiple) {
        value = Array.from(field.selectedOptions, function (o) { return o.value; });
      } else {
        value = field.value;
      }

      if (value == null || value === '' || (Array.isArray(value) && !value.length)) return;

      if (name in properties) {
        properties[name] = [].concat(properties[name], value);
      } else {
        properties[name] = value;
      }
    });

    return properties;
  }

  function syncToQuotify() {
    window.Quotify = window.Quotify || {};
    window.Quotify.properties = getProperties();
  }

  function bindPropertyListeners() {
    document
      .querySelectorAll('[name^="properties["]')
      .forEach(function (field) {
        field.addEventListener('change', syncToQuotify);
        field.addEventListener('input', syncToQuotify);
      });
  }

  bindPropertyListeners();
  syncToQuotify();
})();
  } catch(e) { console.error(e); }
})();

})();
